<template>
    <div></div>
</template>

<script>
// const httpUrl = 'http://192.168.0.8:10086'
// const httpUrl = 'http://admin.zhuineng.com:8090'
const httpUrl = 'http://jsy.zhuineng.com/api'
const size='small'
export default {
    name: '',
    httpUrl,
    size
}
</script>

<style scoped>

</style>
